/**
 * Has Root deactivated this account?
 *
 * The backend answers every request from a deactivated account with a 403 that
 * carries `deactivated: true` and Root's `reason` (`auth.AccountDeactivated`).
 * The API client notes it here; `<account-deactivated>` shows it once, as a
 * pop-up over the page, instead of an error on every panel.
 */

import { Atom } from './atom.ts';

export interface Deactivation {
  reason: string | null;
}

export const accountDeactivated = new Atom<Deactivation | null>(null);

/** Read a 403 body; true when it was the deactivated-account answer. */
export function noteForbiddenBody(body: unknown): boolean {
  if (!body || typeof body !== 'object' || (body as { deactivated?: unknown }).deactivated !== true) return false;
  const reason = (body as { reason?: unknown }).reason;
  if (!accountDeactivated.value) {
    accountDeactivated.set({ reason: typeof reason === 'string' && reason.trim() ? reason.trim() : null });
  }
  return true;
}
